import { faEnvelope as fasEnvelope } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import autobind from "autobind-decorator";
import type { InputHTMLAttributes, ReactNode } from "react";
import React from "react";
import type { FieldRenderProps } from "react-final-form";
import { FormInput } from "./FormInput";
import type { FormInputProps, FormInputState } from "./FormInput";

export type FormEmailProps = FormInputProps;

const EMAIL_REGEXP =
	/^(([^<>()[\]\\.,;:\s@"\u00C0-\u017F]+(\.[^<>()[\]\\.,;:\s@"\u00C0-\u017F]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9\u00C0-\u017F]+\.)+[a-zA-Z]{2,}))$/;

export class FormEmail<
	Props extends FormInputProps = FormInputProps,
	State extends FormInputState = FormInputState,
> extends FormInput<string, Props, State> {
	public static defaultProps: Partial<FormInputProps<number>> = {
		type: "email",
		prepend: <FontAwesomeIcon icon={fasEnvelope} />,
		autoComplete: "email",
	};

	public static validate(email: string): string {
		if (!EMAIL_REGEXP.test(email)) {
			return "Érvénytelen e-mail cím!";
		}
	}

	@autobind
	protected handleValidate(email: string, allValues: Record<string, any>): string {
		const { required } = this.props;

		if (this.isDisabled()) {
			return undefined;
		}

		if (email) {
			const error = FormEmail.validate(email);

			if (error) {
				return error;
			}
		} else if (required) {
			return "Az email cím megadása kötelező!";
		}

		return super.handleValidate(email, allValues);
	}

	protected getInputProps(fieldProps: FieldRenderProps<string>): InputHTMLAttributes<HTMLInputElement> {
		const { id, name, autoComplete } = this.props;
		const {
			input: { value = "" },
		} = fieldProps;
		const itemId = id || name + this.id;

		if (autoComplete === "off" || !value?.includes("@")) {
			return super.getInputProps(fieldProps);
		}

		return {
			...super.getInputProps(fieldProps),
			list: `${itemId}-dataList`,
		};
	}
	protected renderDataList(dataListId: string, dataList: string[], value: string): ReactNode {
		const { autoComplete } = this.props;

		if (dataList) {
			return super.renderDataList(dataListId, dataList, value);
		}

		if (autoComplete === "off" || typeof value !== "string" || !value.includes("@")) {
			return null;
		}

		const typed = `${value}`.split("@")[0];
		const domains = ["@gmail.com", "@freemail.hu", "@icloud.com", "@hotmail.com", "@citromail.hu"];

		return (
			<datalist id={dataListId}>
				{domains.map((item: string) => (
					<option key={item} value={`${typed + item}`} />
				))}
			</datalist>
		);
	}
}
